import React, {useEffect} from 'react';
import {Button, Divider, Form, Modal} from "antd";
import {TrashCanIcon} from "@components/icons/Icons";
import {showResponse} from "@services/Api";
import {useBoxesRemoveBoxMutation} from "@mwServices/Boxes";

const BoxesDeleteModal = ({isModalOpen, box, onCancel}) => {
    const [postRemoveBox, removeBoxResponse] = useBoxesRemoveBoxMutation();
    const [form] = Form.useForm();

    useEffect(() => {
        showResponse(removeBoxResponse, 'Box removed from collection.', 'Sorry, there was a problem removing the box from your collection.');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [removeBoxResponse]);

    return (
        <Modal title={null} open={isModalOpen} onCancel={onCancel} centered={true} destroyOnClose={true} footer={null} className="remove-comic-modal">
            <Form
                layout="vertical"
                form={form}
                onFinish={async () => {
                    let sanitisedData = {box_ids: [box.id].join(','),};

                    await postRemoveBox(sanitisedData);
                }}
            >
                <div className="text-center">
                    <TrashCanIcon className="icon50" /><br/>
                    <span>You're About To Remove This Box.</span>
                </div>

                <Divider />
                <div className="text-center">
                    <Button type="primary"  shape="round"  size="large" htmlType="submit">
                        REMOVE BOX
                    </Button><br/>
                    <Button type="link" onClick={onCancel} >CANCEL</Button>
                </div>
            </Form>
        </Modal>
    );
};

export default BoxesDeleteModal;